import { SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";
import { CloseButton } from "../buttons";

export const Form = (props: {
  children: ReactNode;
  className?: string;
  style?: object;
}) => {
  const rootStyle: SxProps<Theme> = {};

  return (
    <form style={props.style} className={props.className} onSubmit={(e) => e.preventDefault()}>
      {props.children}
    </form>
  );
};
